import React from 'react';
import { number } from 'prop-types';
import { Translate } from 'react-localize-redux';
import styles from './questionSummaryLegend.module.css';
import { withLang, langType } from '../../i18n';
import { toLocaleNumber } from '../../util';

const QuestionSummaryLegend = ({
  groupValue,
  lang,
  standardDeviation,
  minValue,
  maxValue,
  translate: t
}) => {
  const localizeNumber = (value) => toLocaleNumber(value, lang);

  const getStandardDeviation = () => (
    <div className={styles.legendItem}>
      <div className={styles.legendValue}>
        {localizeNumber(standardDeviation)}
      </div>
      <div className={`${styles.legendDescription} ${styles.top}`}>
        <p><Translate id="surveySummary.standardDeviation" /></p>
        <div className={styles.minMax}>
          <p>
            <Translate id="surveyStatistics.smallest" />: {`${minValue} `}
            <Translate id="surveyStatistics.largest" />: {maxValue}
          </p>
        </div>
      </div>
    </div>
  );

  return (
    <div className={styles.legend}>
      <div className={styles.legendItem}>
        <div className={styles.legendValue} aria-label={t('surveySummary.groupAverage')}>
          {localizeNumber(groupValue)}
        </div>
        <div className={styles.legendDescription} aria-hidden="true">
          <p><Translate id="surveySummary.groupAverage" /></p>
        </div>
      </div>
      {standardDeviation !== null ? getStandardDeviation() : ''}
    </div>
  );
};

QuestionSummaryLegend.propTypes = {
  groupValue: number.isRequired,
  standardDeviation: number.isRequired,
  minValue: number.isRequired,
  maxValue: number.isRequired,
  ...langType
};

export default withLang(QuestionSummaryLegend);
